<div class="downloading-pdf-cover">
  <div class="pdf-loading-message">
    <div class="pdf-load-speeding-wheel"></div>
    <label>{{ (type === 'upload' ? 'labels.fileUploadStarted' : 'labels.fileRemoveStarted') | translate }}</label>
  </div>
</div>
